import React from "react";
import { Col } from "react-bootstrap";
import { Link } from "react-router";
import googlePlay from "../../../assets/images/google-play.svg";
import appStore from "../../../assets/images/app-store.svg";

import Image from '../../atoms/Image/Image';
import FormNewsletter from "../../molecules/Form/FormNewsletter";

const FooterTop = () =>{
    return(
        <>
        <Col className="col-12 col-lg-4 mb-3 mb-lg-0">
            <div className="footer__booking position-relative p-4">
                <h3 className="h3">About your booking</h3>
                <ul className=" m-0 footer__booking-list">
                    <li><Link to="#" className="gray small">View, modify or Cancel a booking</Link></li>
                    <li><Link to="#" className="gray small">Manage your booking</Link></li>
                </ul>
            </div>
        </Col>
        <Col className="col-12 col-lg-4 mb-3 mb-lg-0">
        <div className="footer__booking position-relative p-4">
            <h3 className="h3">Exclusive offers</h3>
            <p>Sign up to our newsletter to receive our latest offers</p>
            <FormNewsletter />
            {/* <div className="footer__booking-offer_arrow">
                <Link to="/"><FontAwesomeIcon icon={faArrowRight} /></Link>
            </div> */}
        </div>
    </Col>
    <Col className="col-12 col-lg-4 mb-3 mb-lg-0">
        <div className="footer__booking position-relative p-4">
            <h3 className="h3">Same smart app. More mobility.</h3>
            <Link to="/">For more information</Link>
            <div className="d-flex mt-4 footer__booking-download">
                <figure className="footer__booking-download-image me-3"><Link to=""><Image src={googlePlay} alt="google play" width="" height="" /></Link></figure>
                <figure className="footer__booking-download-image"><Link to=""><Image src={appStore  } alt="app store" width="" height="" /></Link></figure>
            </div>
        </div>
    </Col>
    </>
    )
}
export default FooterTop;